<template>
  <div class="popup-block btn-right">
    <Popover placement="bottom-end" v-model="customDetailsPop" popper-class="smallpopover">
      <div class="popover-primary">
        <div class="popover-primary-header">
          <h3>Details</h3>
          <span class="remove-icon" @click="customDetailsPop = false">
            <svgicon name="cancel" width="10" height="10" :original="true" />
          </span>
        </div>
        <div class="popover-primary-body">
          <div
            class="col-lg-12 no-padding inputgrid"
            v-for="customField in customFields"
            :key="customField.id"
          >
            <div class="col-lg-12 no-padding">
              <label>{{customField.label}}</label>
            </div>
            <div class="col-lg-12 no-padding">
              <input
                class="w200"
                v-if="customField.type ==='textbox'"
                :id="customField.name"
                v-model="cfields[customField.name]"
                v-on:keyup="changeCustomfields(customField)"
              />
              <DatePicker
                v-if="customField.type ==='date'"
                type="date"
                v-model="cfields[customField.name]"
                :clearable="false"
                size="small"
              />
            </div>
          </div>
          <button class="btn btn-primary floatright" @click="updateCustomFields">Save</button>
        </div>
      </div>
      <div slot="reference">
        <svgicon name="details" width="12" height="12" :original="true" class="iconspace" />Details
      </div>
    </Popover>
  </div>
</template>
<script>
export default {
  props: {
    customFields: Array,
    invoice: Object,
  },
  data() {
    return {
      customDetailsPop: false,
      cfields: {},
    };
  },
  created() {
    if (this.invoice.custom_fields) {
      this.cfields = this.invoice.custom_fields;
    }
  },
  methods: {
    async updateCustomFields() {
      if (this.customFields.length) {
        const hasAnyError = this.customFields.reduce(
          (validateField, customField) => {
            if (customField.required && !this.cfields[customField.name]) {
              validateField.push(`${customField.label} can't be blanks<br/>`);
            }
            return validateField;
          },
          [],
        );
        if (hasAnyError.length) {
          this.$error({ message: hasAnyError.toString() });
        } else {
          this.customFields.forEach((obj) => {
            if (obj.type === 'date') {
              const fieldName = obj.name;
              this.cfields[fieldName] = this.cfields[fieldName].toDateString();
            }
          });
          const result = await this.$store.dispatch(
            'invoice/customFieldsUpdate',
            {
              id: this.invoice.id,
              fields: this.cfields,
            },
          );
          if (result.custom_fields) {
            this.$success({
              message: `${this.invoice.invoice_number} ${this.$getSuccess(
                'INVOICE_CUSTOMFIELDS_UPDTAE',
              )}`,
            });
          }
          if (result.error) {
            this.$error({ message: result.error });
          }
        }
      }
    },
  },
};
</script>
<style lang="scss">
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

.popup-block {
  margin-top: -25px;
  position: absolute;
  right: 0;
  font: 1.2rem $fontSemibold;
  color: #404040;
  cursor: pointer;
  border: none;
  text-transform: uppercase;
}
.popover-primary {
  textarea {
    border: 1px solid #dee5e6;
    width: 100%;
    border-radius: 2px;
    padding: 10px;
    margin: 20px 0;
    outline: none;
  }
  .right-btn {
    float: right;
  }
}
.payment-actions{
  width: calc(100% - 960px);
  text-align: right;
  .action{
    display: inline-block;
    padding: 0 10px;
    cursor: pointer;
    text-transform: uppercase;
    font-family:$fontSemibold;
    &.error-msg{
      .svg-icon {
        position: relative;
        top:-2px;
      }
    }
    &-accordian{
      cursor: pointer;
    }
    &-secondary{
      color: #404040;
      font-family:$fontSemibold;
      font-size: 1.2rem;
    }
  }
}
.table-popover {
  .card-col {
    padding: 6px 0px;
    color: #404040;
  }
  .popover-table-row{
    .card-col{
      font-family:$fontSemibold;
    }
  }
}
.inputgrid {
  margin: 20px 0;
  label {
    color: #6e6e6e;
    font-size: 1rem;
  }
  input {
    border-bottom: 1px solid #dee5e6;
    border-top: 1px solid transparent;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    height: 30px;
    font-size: 12px;
    outline: none;
  }
}
.floatright {
  float: right;
}
.smallpopover {
  .popover-primary {
    min-width: 230px;
  }
}
.iconspace {
  margin-right: 5px;
}
.topmargin{
  margin-top: -3px;
}
.btn-right {
  right: 40px !important;
}
</style>
